import React from "react";
import "./SobrePage.module.scss";
import logo from "../../assets/logo-transparente.png";

const SobrePage = () => {
  return (
    <div className="sobre-container">
      <div className="sobre-header">
        <img src={logo} alt="Logo do Sistema" className="sobre-logo" />
        <h1>Sobre o Sistema de Controle de Vendas</h1>
      </div>

      <div className="sobre-content">
        <section>
          <h2>📌 Objetivo do Sistema</h2>
          <p>
            Este sistema foi desenvolvido para gerenciar o estoque, vendas,
            clientes, usuários e orçamentos de maneira eficiente e integrada.
            Ele permite controlar produtos, gerar orçamentos em PDF, registrar
            vendas e gerenciar níveis de acesso de usuários.
          </p>
        </section>

        <section>
          <h2>🛠 Tecnologias Utilizadas</h2>
          <ul>
            <li>Frontend: React, SASS/SCSS</li>
            <li>Backend: Node.js, Express</li>
            <li>Banco de Dados: MySQL</li>
            <li>Bibliotecas: SweetAlert2, React-PDF, Axios</li>
            <li>Deploy/Serviços: Render, LocalStorage para sessões</li>
          </ul>
        </section>

        <section>
          <h2>👥 Equipe / Desenvolvedor</h2>
          <p>
            Desenvolvido por <strong>Danilo Braga</strong>. Experiência com
            WMS, sistemas ERP, desenvolvimento full stack e automação de
            processos logísticos.
          </p>
        </section>

        <section>
          <h2>🔐 Recursos do Sistema</h2>
          <ul>
            <li>Login e controle de níveis de acesso</li>
            <li>Gerenciamento de produtos e estoque</li>
            <li>Registro de vendas com forma de pagamento e troco</li>
            <li>Cadastro e gerenciamento de usuários</li>
            <li>Cadastro de clientes com upload de logo</li>
            <li>Criação e download de orçamentos em PDF</li>
            <li>Modo escuro (dark mode) opcional</li>
          </ul>
        </section>

        <section>
          <h2>📚 Documentação</h2>
          <p>
            Todas as páginas e funcionalidades estão documentadas nesta seção,
            incluindo explicações detalhadas, exemplos de uso e screenshots.
          </p>
        </section>
      </div>
    </div>
  );
};

export default SobrePage;
